import axios from "axios";
import api from "./api";
import AuthService from "../security/AuthService";

const inquireFilePath = (filepath) => {
	console.log("inquireFilePath " + filepath);
	if (filepath && filepath != null && filepath != undefined && filepath != "undefined") {
		let _filepath = filepath.replaceAll("\\", "\/");
		if (_filepath.indexOf("/assets/layout/images") >= 0) {
			return _filepath;
		}
		return `${process.env.REACT_APP_API_URL}/files/filesystem/${_filepath}`;
	}else{
		return null;
	}

}
const uploadImage2 = async (type, imageFile) => {
	console.log("uploadImage " + imageFile);
	console.log("uploadImage " + type);

	let formData = new FormData();
	formData.append('imageFile', imageFile);


	const apiPath = `/files/upload`;
	let url = apiPath;
	const response = api.post(url, formData);
	return response;
}
const uploadImage = async (apiParams) => {
	const apiPath = `/files/upload`;

	console.log("upload " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}

const removeFile = async (apiParams) => {
	const apiPath = `/files/remove`;

	console.log("upload " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}
const uploadProfile = async (apiParams) => {
	const apiPath = `/files/uploadprofile`;

	console.log("uploadprofile " + apiPath);
	let url = apiPath;
	let data = apiParams;

	const response = api.post(url, data);
	return response;
}

const inquireFile = async (filepath) => {

	let _filepath = encodeURIComponent(filepath);



	const apiPath = `/files/inquirefile?filepath=${_filepath}`;


	console.log("inquireFile " + apiPath);

	const response = await api.get(apiPath);
	return response;
}


const inquireFileName = async (filepath) => {

	let _filepath = encodeURIComponent(filepath);



	const apiPath = `/files/filesystem/${filepath}`;


	console.log("inquireFile " + apiPath);

	const response = await api.get(apiPath);
	return response;
}

const FileService = {
	uploadImage,
	removeFile,
	uploadProfile,
	inquireFile,
	inquireFileName,
	inquireFilePath

};

export default FileService;
